import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { useNewConsentModalContext } from 'pages/SharePage/Context/NewConsentModalContext';
import { useTabAreaContext } from 'pages/SharePage/Context/TabAreaContext';
import React, { useState } from 'react';
import consentRequests from 'services/consentRequests';
import { toast } from 'react-toastify';
import MHDRequests from 'services/MHDRequests';
import { ToastMessage } from 'components';
import './NewConsentModal.css';
import { LoadingHU } from 'components/LoadingHU';
import HUTab from './components/HUTab';
import PersonTab from './components/PersonTab';

export function NewConsentModal() {
  const {
    newConsentModalState, setNewConsentModalState, vigency, setVigency,
  } = useNewConsentModalContext();
  const { refetchTabArea } = useTabAreaContext();
  const [personTabIsOpen, setPersonTabIsOpen] = useState(true);
  const [identifierToConsent, setIdentifierToConsent] = useState('');
  const [nameToConsent, setNameToConsent] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const initialStateModal = {
    isOpen: false,
    subjectId: 'Não Encontrado',
    pat_id: 'Não Encontrado',
    pat_name: 'Não Encontrado',
    consentType: 'Não Encontrado',
  };

  async function handleNewConsent(subjectId, patientId) {
    if (personTabIsOpen === true) {
      await consentRequests.appc_request(
        'Permit',
        subjectId,
        [patientId],
        null,
        vigency,
      );
    } else {
      await consentRequests.appc_request(
        'Permit',
        subjectId,
        null,
        [patientId],
        vigency,
      );
    }
    setNewConsentModalState(initialStateModal);
    refetchTabArea();
    toast.success(
      <ToastMessage type="success">Consentimento concedido.</ToastMessage>,
    );
  }

  async function getName(id) {
    setLoading(true);
    try {
      const patientJson = await MHDRequests.getPatientJson({ patientId: id });
      if (patientJson === 'not_found') throw new Error('Paciente não encontrado');
      const name = patientJson.name[0].text;
      setNameToConsent(name);
      setConfirm(true);
    } catch (err) {
      toast.info(
        <ToastMessage type="info">
          Verifique os dados e tente novamente.
          {' '}
        </ToastMessage>,
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Dialog
        scroll="body"
        className="newConsentModal"
        open={newConsentModalState.isOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {confirm && nameToConsent ? (
          <>
            <DialogTitle id="confirm-title">
              Confirmar novo consentimento
            </DialogTitle>
            <DialogContent>
              <div className="newConsentModal-text">
                <p>
                  Atenção: ao confirmar essa ação
                  <b>
                    {' '}
                    {nameToConsent}
                    {' '}
                  </b>
                  terá acesso a suas informações de saúde
                  {
                    vigency ? (
                      <>
                        {' '}
                        por
                        <b>
                          {' '}
                          {vigency}
                          {' '}
                        </b>
                        dia(s).
                      </>
                    )
                      : (
                        <>
                          <b> até revogação manual </b>
                        </>
                      )
                  }

                </p>
              </div>
            </DialogContent>
            <DialogActions>
              <div className="listButtons">
                <button
                  className="newConsentModal-closeButton"
                  onClick={() => setNewConsentModalState({
                    ...newConsentModalState,
                    isOpen: false,
                  })}
                  type="button"
                >
                  Cancelar
                </button>
                <button
                  disabled={identifierToConsent === ''}
                  className="newConsentModal-shareButton"
                  type="button"
                  onClick={() => handleNewConsent(
                    newConsentModalState.subjectId,
                    identifierToConsent,
                  )}
                >
                  Confirmar
                </button>
              </div>
            </DialogActions>
          </>
        ) : (
          <>
            <DialogTitle id="newConsent-title">Novo consentimento</DialogTitle>
            <DialogContent>
              <div className="newConsentModal-tabs">
                <button
                  className={personTabIsOpen && 'newConsentModal-openTab'}
                  onClick={() => {
                    setPersonTabIsOpen(true);
                    setIdentifierToConsent('');
                    setNameToConsent('');
                    setVigency(30);
                  }}
                >
                  Indivíduo
                </button>
                <button
                  className={
                    !personTabIsOpen
                    && 'newConsentModal-openTab instituitionButtonModal'
                  }
                  onClick={() => {
                    setPersonTabIsOpen(false);
                    setIdentifierToConsent('');
                    setNameToConsent('');
                    setVigency(30);
                  }}
                >
                  Unidade de Saúde
                </button>
              </div>

              {personTabIsOpen ? (
                <PersonTab
                  setIdentifierToConsent={setIdentifierToConsent}
                  setVigency={setVigency}
                />
              ) : (
                <HUTab
                  setVigency={setVigency}
                  setIdentifierToConsent={setIdentifierToConsent}
                  setNameToConsent={setNameToConsent}
                />
              )}
            </DialogContent>
            <DialogActions>
              <button
                className="newConsentModal-closeButton"
                onClick={() => setNewConsentModalState({
                  ...newConsentModalState,
                  isOpen: false,
                })}
                type="button"
              >
                Fechar
              </button>
              <button
                disabled={identifierToConsent === ''}
                className="newConsentModal-shareButton"
                type="button"
                onClick={() => (personTabIsOpen
                  ? getName(identifierToConsent)
                  : setConfirm(true))}
              >
                Compartilhar
              </button>
            </DialogActions>
          </>
        )}

        <LoadingHU state={loading} />
      </Dialog>
    </>
  );
}
